<template>
    <div class="row sectionsCreate-block mt-4">
        <div class="col-xl-12 col-xxl-12 p-lr-0-sm">
            <div class="row multisteps-form">
                <div class="col-sm-12 col-md-7 col-lg-7 col-xl-8 col-xxl-7 p-lr-0-sm">
                    <form class="multisteps-form__form dis-flex flex-column" @submit.prevent>
                        <div class="card p-3 dis-flex flex-column mb-4 multisteps-form__content col-sm-12">
                            <div class="row">
                                <div class="col-sm-12 p-lr-0-sm">
                                    <div class="dis-flex col-12 p-0">
                                        <div class="col-7 p-0 dis-flex flex-m"><i class="uis uis-sort-amount-down mr-2 text-rose"></i>
                                            <h5 class="text-sm-b">Create Section</h5>
                                        </div>
                                        <div class="col-5 p-0 ml-auto">
                                            <div class="uploaded-user-icon-show w-full dis-flex flex-m flex-r" v-if="createSection.icon">
                                                <small class="text-success txt-italic mr-2">Uploaded icon -</small>
                                                <div class="any-category-user-icon" :style="{'background-image': `url(data:image/png;base64,${createSection.icon})`}"></div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row mt-3">
                                        <div class="col-sm-6 p-lr-0-sm mb-2">
                                            <label>Category</label>
                                            <div class="pos-relative">
                                                <select class="multisteps-form__input form-control pointer" @change="(event) => {
                                                    createSection.category_id = event.target.value
                                                    createSection.subcategory_id = null
                                                }">
                                                    <option :selected="createSection.category_id === null" disabled="" hidden>Choose Category</option>
                                                    <option v-for="(thisCategory) in categoriesList" :key="thisCategory.id" :value="thisCategory.id" :selected="createSection.category_id == thisCategory.id">{{ componentsGetNormalName(thisCategory.name) }}</option>
                                                </select>
                                                <i class="uis uis-angle-down pos-absolute selector-angle-down fs-20 pointer-none text-rose"></i>
                                            </div>
                                        </div>
                                        <div class="col-sm-6 p-lr-0-sm mb-2" v-if="!(createSection.category_id === null)">
                                            <label>Subcategory</label>
                                            <div class="pos-relative">
                                                <select class="multisteps-form__input form-control pointer" @change="createSection.subcategory_id = $event.target.value">
                                                    <option :selected="createSection.subcategory_id === null" disabled="" hidden>Choose Subcategory</option>
                                                    <template v-for="(thisCategoryArray, thisCategoryArrayKey) in subCategoriesList" :key="thisCategoryArrayKey">
                                                        <template v-if="createSection.category_id == thisCategoryArrayKey">
                                                            <option v-for="(thisSubCategory) in thisCategoryArray.data" :key="thisSubCategory.id" :value="thisSubCategory.id" :selected="createSection.subcategory_id == thisSubCategory.id">{{ componentsGetNormalName(thisSubCategory.name) }}</option>
                                                        </template>
                                                    </template>
                                                </select>
                                                <i class="uis uis-angle-down pos-absolute selector-angle-down fs-20 pointer-none text-rose"></i>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row mt-3">
                                        <div class="col-8 col-lg-7 p-lr-0-sm mt-3">
                                            <div class="col-sm-12 p-0 dis-flex">
                                                <div class="col-9 col-lg-10 p-0">
                                                    <div class="dis-flex flex-m flex-sb multisteps-form__content">
                                                        <label>Name</label>
                                                        <div class="btn small-form-btn fs-10 pointer" title="Translations Languages">
                                                            <select class="translate-lang-swich pointer text-uppercase" name="translation-lang" @change="createSection.selected_lang = $event.target.value">
                                                                <option v-for="(thisName, thisNameKey) in createSection.name" :key="thisNameKey" :value="thisNameKey" :selected="createSection.selected_lang == thisNameKey">{{ thisNameKey }}</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                    <template v-for="(thisName, thisNameKey) in createSection.name" :key="thisNameKey">
                                                        <input v-if="createSection.selected_lang == thisNameKey" class="multisteps-form__input form-control" type="text" placeholder="Section Name" v-model="createSection.name[thisNameKey]">
                                                    </template>
                                                </div>
                                                <div class="col-3 col-lg-3 dis-flex flex-column flex-m pr-0">
                                                    <div class="dis-flex flex-m flex-sb multisteps-form__content">
                                                        <label class="mb-0">Icon</label>
                                                    </div>
                                                    <div class="pick-an-icon mt-auto pointer">
                                                        <label class="pointer" for="categoryIcon">
                                                            <i class="uis uis-scenery mr-2 fs-25 pointer"></i>
                                                        </label>
                                                        <input accept="image/png, image/jpeg" type="file" @change="uploadSectionIcon($event)" id="categoryIcon">
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-4 col-lg-5 dis-flex flex-column mt-auto p-0">
                                            <div class="col-sm-12 p-lr-0-sm dis-flex">
                                                <button class="btn button-create-atrb-btn ml-auto" type="button" title="Create Section" :disabled="(!componentsAttributesIsAllNamesLength(createSection.name, 3) || createSection.category_id === null || createSection.subcategory_id === null)" @click="createNewSection()">Create</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
                <div class="col-sm-12 col-md-5 col-lg-5 col-xl-4 col-xxl-5 p-lr-0-sm">
                    <div class="card multisteps-form__content p-3 dis-flex flex-column mb-4 max-h-c100-210vh">
                        <div class="dis-flex flex-m flex-sb col-12 p-0 mb-3">
                            <div class="dis-flex flex-m">
                                <i class="uis uis-sort-amount-down mr-2 text-rose"></i>
                                <h5 class="text-sm-b">All Sections</h5>
                            </div>
                            <small class="text-rose txt-italic">Created</small>
                        </div>
                        <div class="content-crds-messages-scroll">
                            <template  v-for="(thisSubCategoryArray, thisSubCategoryId) in sectionsList" :key="thisSubCategoryId">
                                <div class="row mb-2" v-for="thisSection in thisSubCategoryArray.data" :key="thisSection.id">
                                    <div class="col-sm-12 p-lr-0-sm">
                                        <div class="bg-white-list">
                                            <div class="dis-flex flex-m flex-sb">
                                                <div class="dis-flex flex-m">
                                                    <div class="mr-2 any-category-user-icon" v-if="thisSection.icon" :style="{'background-image': `url(data:image/png;base64,${thisSection.icon})`}"></div>
                                                    <h5 class="text-sm-b">{{ componentsGetNormalName(thisSection.name) }}</h5>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </template>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import componentsGetNormalName from '@/mixins/componentsGetNormalName.js'

export default {
    mixins: [componentsGetNormalName],
    props: {
        categoriesList: {
            type: Array,
            required: true
        },
        subCategoriesList: {
            type: Object,
            required: true
        },
        sectionsList: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            createSection: {
                selected_lang: 'en',
                category_id: null,
                subcategory_id: null,
                name: {},
                icon: null,
            }
        }
    },
    methods: {
        createNewSection: function() {
            let thisNewSectionData = JSON.parse(JSON.stringify(this.createSection))
            let newSectionData = {
                id: (Math.floor(Math.random() * 100000000) + 100000),
                category_id: thisNewSectionData.category_id,
                subcategory_id: thisNewSectionData.subcategory_id,
                name: thisNewSectionData.name,
                icon: thisNewSectionData.icon,
            }
            socket.emit('categories:createSection', newSectionData, (success) => {
                this.$emit('updateSectionsList')
            })
            if (this.sectionsList.hasOwnProperty(`${thisNewSectionData.subcategory_id}`)) {
                this.sectionsList[`${thisNewSectionData.subcategory_id}`].data.push(newSectionData)
            } else {
                this.sectionsList[`${thisNewSectionData.subcategory_id}`] = {
                    opened: false,
                    data: [newSectionData]
                }
            }

            this.createSection.selected_lang = 'en'
            this.createSection.icon = null
            this.createSection.category_id = null
            this.createSection.subcategory_id = null
            for (const key in this.createSection.name) {
                this.createSection.name[key] = ''
            }
        },
        componentsAttributesIsAllNamesLength: function(thisNameObj, minLength) {
            let allNameIsWithMinLength = true

            for (const key in thisNameObj) {
                const thisName = thisNameObj[key]
                if (thisName.length < minLength) {
                    allNameIsWithMinLength = false
                    break
                }
            }

            return allNameIsWithMinLength
        },
        uploadSectionIcon: function(thisEvent) {
            let thisVue = this
            for (const key in thisEvent.target.files) {
                const thisNewImage = thisEvent.target.files[key]
                if (typeof thisNewImage != 'object') continue;
                else if (key == 'length') continue;
                else if (thisNewImage.type.indexOf('image') != 0) continue;

                const reader = new FileReader();
                reader.onload = function() {
                    const base64 = this.result.replace(/.*base64,/, '');
                    thisVue.createSection.icon = base64
                };
                reader.readAsDataURL(thisNewImage);
                break;
            }
            thisEvent.target.value = ''
        }
    },
    watch: {
        '$store.state.languages': {
            handler: function(newLangObj, oldLangObj) {
                for (const key in newLangObj) {
                    if (!this.createSection.name.hasOwnProperty(key)) {
                        this.createSection.name[key] = ''
                    }
                }
            },
            deep: true
        }
    },
    mounted: function() {
        this.$emit('updateSectionsList')

        for (const key in this.$store.state.languages) {
            if (!this.createSection.name.hasOwnProperty(key)) {
                this.createSection.name[key] = ''
            }
        }
    }
}
</script>

<style>

</style>